export const AUDIT_LOG_CATEGORIES = {
    ACCESS: "Access",
    ERROR: "Error",
    USER: "User",
    SECURITY: "Security",
    SYSTEM: "System",
};

export const AUDIT_LOG_SEVERITY = {
    INFO: "Info",
    WARNING: "Warning",
    ERROR: "Error",
    CRITICAL: "Critical",
};

export const CATEGORY_STYLES = {
    [AUDIT_LOG_CATEGORIES.ACCESS]: "text-blue-700 bg-blue-100",
    [AUDIT_LOG_CATEGORIES.ERROR]: "text-red-700 bg-red-100",
    [AUDIT_LOG_CATEGORIES.USER]: "text-indigo-700 bg-indigo-100",
    [AUDIT_LOG_CATEGORIES.SECURITY]: "text-amber-700 bg-amber-100",
    [AUDIT_LOG_CATEGORIES.SYSTEM]: "text-slate-600 bg-slate-100",
};

export const SEVERITY_STYLES = {
    [AUDIT_LOG_SEVERITY.INFO]: "text-green-700 bg-green-100",
    [AUDIT_LOG_SEVERITY.WARNING]: "text-amber-700 bg-amber-100",
    [AUDIT_LOG_SEVERITY.ERROR]: "text-red-700 bg-red-100",
    [AUDIT_LOG_SEVERITY.CRITICAL]: "text-white bg-red-600",
};

// Column names shown in the table header
// Adjust the order or labels here to change the table layout.
export const AUDIT_LOG_COLUMN_NAMES = ["Event", "User", "Category", "Severity", "Timestamp"];

// Sample / seed data
// Replace or extend this array with real API data when the backend is ready.
// Each entry matches the shape that AuditLogRow expects.
export const SAMPLE_AUDIT_LOGS = [
    {
        id: "log-001",
        event: "User login successful",
        description: "User authenticated via username and password.",
        user: "alice@example.com",
        category: AUDIT_LOG_CATEGORIES.ACCESS,
        severity: AUDIT_LOG_SEVERITY.INFO,
        timestamp: "2026-03-25T08:14:32Z",
        ipAddress: "192.168.1.10",
    },
    {
        id: "log-002",
        event: "Failed login attempt",
        description: "Incorrect password entered three times for this account.",
        user: "bob@example.com",
        category: AUDIT_LOG_CATEGORIES.ACCESS,
        severity: AUDIT_LOG_SEVERITY.WARNING,
        timestamp: "2026-03-25T08:22:11Z",
        ipAddress: "10.0.0.44",
    },
    {
        id: "log-003",
        event: "Account locked",
        description: "Account automatically locked after five consecutive failed login attempts.",
        user: "bob@example.com",
        category: AUDIT_LOG_CATEGORIES.SECURITY,
        severity: AUDIT_LOG_SEVERITY.CRITICAL,
        timestamp: "2026-03-25T08:22:58Z",
        ipAddress: "10.0.0.44",
    },
    {
        id: "log-004",
        event: "User created",
        description: "A new user account was created by an administrator.",
        user: "admin@example.com",
        category: AUDIT_LOG_CATEGORIES.USER,
        severity: AUDIT_LOG_SEVERITY.INFO,
        timestamp: "2026-03-25T09:01:05Z",
        ipAddress: "192.168.1.1",
    },
    {
        id: "log-005",
        event: "Permission denied",
        description: "User attempted to access a resource without sufficient permissions.",
        user: "charlie@example.com",
        category: AUDIT_LOG_CATEGORIES.ACCESS,
        severity: AUDIT_LOG_SEVERITY.WARNING,
        timestamp: "2026-03-25T09:45:17Z",
        ipAddress: "172.16.0.5",
    },
    {
        id: "log-006",
        event: "Internal server error",
        description: "Unhandled exception thrown in the report generation service.",
        user: "system",
        category: AUDIT_LOG_CATEGORIES.ERROR,
        severity: AUDIT_LOG_SEVERITY.ERROR,
        timestamp: "2026-03-25T10:03:44Z",
        ipAddress: "N/A",
    },
    {
        id: "log-007",
        event: "Password changed",
        description: "User successfully changed their account password.",
        user: "diana@example.com",
        category: AUDIT_LOG_CATEGORIES.SECURITY,
        severity: AUDIT_LOG_SEVERITY.INFO,
        timestamp: "2026-03-25T10:30:00Z",
        ipAddress: "192.168.1.22",
    },
    {
        id: "log-008",
        event: "User deleted",
        description: "A user account was permanently deleted by an administrator.",
        user: "admin@example.com",
        category: AUDIT_LOG_CATEGORIES.USER,
        severity: AUDIT_LOG_SEVERITY.WARNING,
        timestamp: "2026-03-25T11:00:00Z",
        ipAddress: "192.168.1.1",
    },
    {
        id: "log-009",
        event: "Session expired",
        description: "User session timed out after 30 minutes of inactivity.",
        user: "eve@example.com",
        category: AUDIT_LOG_CATEGORIES.ACCESS,
        severity: AUDIT_LOG_SEVERITY.INFO,
        timestamp: "2026-03-25T11:32:10Z",
        ipAddress: "10.0.0.88",
    },
    {
        id: "log-010",
        event: "Database connection failure",
        description: "Could not reach the primary database. Failover triggered.",
        user: "system",
        category: AUDIT_LOG_CATEGORIES.ERROR,
        severity: AUDIT_LOG_SEVERITY.CRITICAL,
        timestamp: "2026-03-25T12:05:55Z",
        ipAddress: "N/A",
    },
    {
        id: "log-011",
        event: "Report downloaded",
        description: "User downloaded a PDF assessment report.",
        user: "frank@example.com",
        category: AUDIT_LOG_CATEGORIES.ACCESS,
        severity: AUDIT_LOG_SEVERITY.INFO,
        timestamp: "2026-03-25T13:14:02Z",
        ipAddress: "192.168.2.9",
    },
    {
        id: "log-012",
        event: "Permissions updated",
        description: "Administrator updated role permissions for a user group.",
        user: "admin@example.com",
        category: AUDIT_LOG_CATEGORIES.SECURITY,
        severity: AUDIT_LOG_SEVERITY.WARNING,
        timestamp: "2026-03-25T14:00:30Z",
        ipAddress: "192.168.1.1",
    },
];
